'use strict';

import React       from 'react';
import PropTypes   from "prop-types";
import PhoneAccess from "../PhoneAccess";

class NavBarTabletPhoneAccess extends React.PureComponent {

	constructor(props) {
		super(props);
	}

	render() {
		return (<li className="navbar-tablet__dropdown-item h-float-none"><PhoneAccess label={this.props.name} isTablet={true} /></li>);
	}

}

NavBarTabletPhoneAccess.propTypes = {
	name: PropTypes.string,
};

export default NavBarTabletPhoneAccess;